import { render, staticRenderFns } from "./TelemetriaPantalla.vue?vue&type=template&id=21c4cd83&"
import script from "./TelemetriaPantalla.vue?vue&type=script&lang=ts&"
export * from "./TelemetriaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports